<template>
  <popup-bg :show-lock="showLock" :full-page="true">
    <div slot="custom-html">
      <div class="filter-title">筛选</div>
      <div class="filter-wrap">
        <h3>留学意向</h3>
        <el-select
          v-model="searchData.intentionCountries"
          clearable
          placeholder="请选择">
          <el-option
            v-for="item in ds.country"
            :label="item.value"
            :value="item.id"
            :key="item.id"/>
        </el-select>
      </div>
      <div class="filter-wrap">
        <h3>客户分级</h3>
        <jm-dict-select
          clearable
          type="dataset"
          v-model="searchData.customerClassification"
          dict-type="student"
          name="customLvType"
        />
      </div>
      <div class="filter-wrap">
        <h3>签约状态</h3>
        <jm-dict-select
          clearable
          type="dataset"
          v-model="searchData.signingStatus"
          dict-type="student"
          name="customLevelType"
        />
      </div>
      <div class="filter-wrap">
        <h3>渠道来源</h3>
        <jm-channel
          v-model="searchData.channel"
          clearable
          filterable/>
      </div>
      <div class="filter-btn-area">
        <el-button @click="clearSearchData">清空条件</el-button>
        <el-button @click="submit">开始查询</el-button>
      </div>
    </div>
    <div slot="close-button">
      <slot name="close-button"></slot>
    </div>
  </popup-bg>
</template>
<script>
import {
  // jmAreaselect,
  jmChannel,
  // jmEducationSelect,
  // jmExamjpSelect,
  jmDictSelect
} from '@/components/tool';
import popupBg from './popupBg';

export default {
  props: {
    showLock: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default() {
        return {
        };
      }
    },
    searchData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      ds: {},
      // searchData: {
      //   activeCountries: '', //意向国家
      //   customerClassification: '', // 客服分级
      //   signingStatus: '', //签约状态
      //   // 渠道
      //   channel: {
      //     custom_from: '',
      //     custom_from_sub: '',
      //     custom_from_thrid: '',
      //     custom_from_fourth: '',
      //     custom_from_fifth: ''
      //   },
      // }
    };
  },
  components: {
    jmChannel,
    jmDictSelect,
    'popup-bg': popupBg
  },
  methods: {
    getDatasource() {
      return this.$http._get({
        url: '/index/Student/searchDs',
      }).then((response) => {
        this.ds = response.data;
        return Promise.resolve(this.ds);
      });
    },
    submit() {
      this.refresh = true;
      this.$emit('update:showLock', false);
    },
    clearSearchData() {
      this.$emit('clearSearchData');
    }
  },
  mounted() {
    this.getDatasource();
  }
};
</script>

<style scoped>
  .filter-title{
    font-size: 4.53vw;
    padding: 5vw 0 0;
    font-weight: 600;
    text-align: center;
  }
  .filter-wrap{
    padding: 0 4vw;
  }
  .filter-wrap > h3{
    font-size: 4.8vw;
    line-height: 5vw;
    padding: 7.4vw 0 3.7vw;
  }
  .filter-wrap .el-select{
    width: 100%;
  }
  .filter-wrap .jm-dict-select,.filter-wrap .jm-channel-select{
    width: 100%;
  }
  .filter-btn-area{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 19vw;
    line-height: 16vw;
    border-top: 1px solid #DFDEE3;
    background: #fff;
    z-index: 9;
    text-align: center;
  }
  .filter-btn-area .el-button{
    height: 10.6vw;
    line-height: 10.6vw;
    border-radius: 5.3vw;
    padding: 0;
    font-size: 3.73vw;
    color: #fff;
    background: #0496ff;
    width: 52vw;
    border: none;
  }
  .filter-btn-area .el-button:first-of-type{
    width: 36.5vw;
    background: #f8f8f8;
    color: #333;
  }
</style>
<style>
  .filter-wrap .jm-dict-select .el-select{
    width: 100% !important;
  }
  .filter-wrap .jm-channel-select .el-select{
    width: 100% !important;
    margin-right: 0;
    margin-bottom: 2vw;
  }
</style>
